import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryClient } from 'providers/AllProviders';
import { OrganizationsResponse } from './types';
import { getOrganizations, updateOrganizations } from './api';
import { CacheKeys } from 'utils/cacheKeys';
import { setCookie } from 'utils/helperFunctions';

export function useGetOrganizations(options?: UseQueryOptions<OrganizationsResponse, Error>) {
  return useQuery<OrganizationsResponse>({
    queryKey: ['organizations'],
    queryFn: () => getOrganizations(),
    ...options
  });
}

export function useUpdateOrganizations() {
  return useMutation({
    mutationFn: (payload: OrganizationsResponse | FormData) => updateOrganizations(payload),
    onSuccess: (data) => {
      if (data?.configuration?.brand_color) {
        setCookie(CacheKeys.themeColor, data.configuration.brand_color);
        window.location.reload();
      }
      queryClient.invalidateQueries({
        queryKey: ['organizations'],
        refetchType: 'active'
      });
    }
  });
}
